const { Type } = require('@sinclair/typebox');
const Blockly = require('blockly');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');

const TOOLTIP = 'A date range search element. Can optionally take a filter to set the default date range.';

/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock reference to the block as a whole
 * @param {Object} mdcBlock Meta Data Configuration block. the group definition from blockGroupConfiguration.js
 * @param {import('blockly').Input} line1OfInputs First line of inputs, already including the Block name and the title field
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    blocklyBlock.setTooltip(TOOLTIP);

    blocklyBlock
        .appendDummyInput()
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField('  Property Name:')
        .appendField(new Blockly.FieldTextInput('meta.createdTime'), 'propertyName');
    blocklyBlock.additionalListNames = ['from', 'to'];
    blocklyBlock
        .appendStatementInput('from')
        .setCheck(['rangeType'])
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField('From:', 'from');
    blocklyBlock
        .appendStatementInput('to')
        .setCheck(['rangeType'])
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField('To:', 'to');

    blocklyBlock.appendStatementInput('filters').setCheck(['filter']).appendField('Filters:');
}

/**
 * @param {{[key: string]: any}} code
 * @param {import('blockly').Block} blocklyBlock
 * @return {{[key: string]: any}}
 */
function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);

    code.fromInputHNode = JSON.parse(Blockly.JavaScript.statementToCode(blocklyBlock, 'from'));
    code.toInputHNode = JSON.parse(Blockly.JavaScript.statementToCode(blocklyBlock, 'to'));
    code.filters = JSON.parse(`[${Blockly.JavaScript.statementToCode(blocklyBlock, 'filters')}]`);
    addCodeProperties(['tooltip', 'propertyName']);

    //nested blocks, including those in `filters` are converted and added automatically

    return code;
}

/** Builds the data dictionary fragment for the Range search element. */
function asDataDictionary(hNode, context) {
    const { id, title, propertyName, format } = hNode;
    //This block tells us nothing about namespaces/relations

    const subDataDictionary = {};

    // Create TypeBox string schema with date-time format (JSON Schema 2020-12 standard)
    // https://json-schema.org/draft/2020-12/json-schema-validation#name-dates-times-and-duration
    const dateTimeSchema = Type.String({
        'x-id': id,
        title: title,
        'x-dataType': 'string',
        'x-propertyName': propertyName,
        format: 'date-time', // JSON Schema 2020-12 standard format for ISO 8601
        'x-displayFormat': format // Custom display format for UI
    });

    const partialTypeDefinition = {
        [propertyName]: dateTimeSchema
    };

    return [subDataDictionary, partialTypeDefinition];
}

function customizeToolbox(block) {
    block.inputs = {
        from: {
            block: {
                type: 'rangeType_DateTime',
                fields: { title: 'From' }
            }
        },
        to: {
            block: {
                type: 'rangeType_DateTime',
                fields: { title: 'To' }
            }
        },
        filters: {
            block: {
                type: 'filter_DateRange'
            }
        }
    };
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode, asDataDictionary, customizeToolbox };
